import React, { Component } from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getTranslation } from 'domain-model';
import { getAxiosInstance } from '../../utils/appWrapper';
import Select from './Select';

class PipeString extends Component {
  static get propTypes() {
    return {
      onChange: PropTypes.func.isRequired,
      value: PropTypes.string,
      isDisabled: PropTypes.bool,
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string,
      required: PropTypes.bool,
      isClearable: PropTypes.bool,
      options: PropTypes.array,
      sessionUser: PropTypes.object.isRequired,
    };
  }

  static get defaultProps() {
    return {
      value: '',
      placeholder: 'Skriv för att söka ...',
      isDisabled: false,
      required: false,
      isClearable: false,
      options: undefined,
    };
  }

  constructor(props) {
    super(props);
    this.state = { options: [] };
    this.loadInitialData = this.loadInitialData.bind(this);
  }

  componentDidMount() {
    this.loadInitialData();
  }

  async loadInitialData() {
    const { name, options } = this.props;

    if (options) {
      this.setState({
        options: options.map(x => ({
          value: x,
          label: getTranslation(`${name}.${x}`).replace(/\|/g, ' > '),
        })),
      });
      return;
    }
    if (name === 'organizationProductCategory') {
      const listedCategories = await getAxiosInstance().get(
        `/categoryTrees?${qs.stringify({
          organization: this.props.sessionUser.organization.id,
        })}`,
      );
      if (listedCategories.data.rows.length === 0) return;
      const response = await getAxiosInstance().get(
        `/categoryTrees/${listedCategories.data.rows[0]?.id}`,
      );

      const loadedOptions = (response.data.categories || []).map(x => ({
        value: x.name,
        label: x.name.replace(/\|/g, ' > '),
      }));
      this.setState({ options: loadedOptions });
      return;
    }
    let requestUrl = '/articleOrigins';
    // TODO fix this. Very hacky.
    if (name === 'productCategory') {
      requestUrl = '/productCategories';
    }
    if (name === 'chain') {
      requestUrl = '/chains';
    }
    const response = await getAxiosInstance().get(requestUrl);
    const loadedOptions = (response.data || response.data.rows || []).map(
      x => ({
        value: x[name],
        label: x[name].replace(/\|/g, ' > '),
      }),
    );
    this.setState({ options: loadedOptions });
  }

  render() {
    const {
      name,
      isDisabled,
      onChange,
      value,
      required,
      isClearable,
      placeholder,
    } = this.props;
    const { options } = this.state;
    return (
      <Select
        name={name}
        isDisabled={isDisabled}
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        required={required}
        isClearable={isClearable}
      />
    );
  }
}

const mapStateToProps = ({ authentication }) => ({
  sessionUser: authentication.sessionUser,
});
export default connect(mapStateToProps)(PipeString);
